
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	output,
} from '@angular/core';
import { NavigationLinkComponent } from '../navigation-link/navigation-link.component';
import { IMenuItem, IMenuItems } from '../navigation.interface';

@Component({
	selector: 'navigation-items',
	standalone: true,
	imports: [NavigationLinkComponent],
	templateUrl: './navigation-items.component.html',
	styleUrl: './navigation-items.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationItemsComponent {
	public items = input<IMenuItems>([]);
	public type = input<string>('item');
	public activeTheme = input<string>();
	public nestingLevel = input<number>(0);
	public onClickItem = output<IMenuItem>();

	protected anyItemExpanded = computed(() =>
		this.items().some((i) => i.below?.length && i.expanded),
	);
}
